import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import lang from '@blade/common/pages/alert-details/lang/index';
import { getTaskTargetStr } from '@blade/common/pages/alert-details/common/util';
import '@blade/common/pages/alert-details/assets/styles/index.scss';
import detailsLevel from '@blade/common/pages/alert-details/components/details-level.vue';
import detailsType from '@blade/common/pages/alert-details/components/details-type.vue';
import detailsThreshold from '@blade/common/pages/alert-details/components/details-threshold.vue';
import detailsFace from '@blade/common/pages/alert-details/components/details-face.vue';
import detailsGatherScatter from '@blade/common/pages/alert-details/components/details-gather-scatter.vue';
import detailsSocialDistance from '@blade/common/pages/alert-details/components/details-social-distance.vue';
import detailsSnapArea from '@blade/common/pages/alert-details/components/details-snap-area.vue';
import detailsStatus from '@blade/common/pages/alert-details/components/details-status.vue';
import detailsOperator from '@blade/common/pages/alert-details/components/details-operator.vue';
import detailsRightBottom from '@blade/common/pages/alert-details/components/details-right-bottom.vue';
import detailsNote from '@blade/common/pages/alert-details/components/details-note.vue';
import traffic from '@blade/common/pages/alert-details/components/traffic.vue';
import AnalysisResult from '@blade-sxp/monitor-center/pages/components/analysis-result/index.vue';
import { permissionlevel } from '@blade/common/constants/role-mode';
let detailsRight = class detailsRight extends Vue {
    details;
    componentName = '';
    activeTab = 'details';
    tabs = [
        {
            name: this.$t('details'),
            key: 'details',
        },
        {
            name: this.$t('analysis'),
            key: 'analysis',
        },
    ];
    permissionCode = '02';
    permissionLevel = permissionlevel;
    get getFavoriteClass() {
        return this.details.favoritesInfos && this.details.favoritesInfos?.favorite ? 'icon-alert-unstarred' : '';
    }
    get getFavorite() {
        return this.details.favoritesInfos && this.details.favoritesInfos?.favorite ? 'alert-unstarred' : 'alert-star';
    }
    get incidentType() {
        return this.details.incidentType;
    }
    onUpdateIncidentType() {
        this.componentName = getTaskTargetStr('incidentType', 'incidentComponent', this.details.incidentType);
    }
    confirmDialog(val) {
        this.$emit('updateDialog');
    }
    handleClick() { }
    closeDialog() {
        this.$emit('closeDialog');
    }
    handleDelete() {
        this.$emit('handleDelete');
    }
    handleStar() {
        this.$emit('handleStar');
    }
    handleIgnore() {
        this.$emit('handleIgnore');
    }
    handleSolved() {
        this.$emit('handleSolved');
    }
};
__decorate([
    Prop()
], detailsRight.prototype, "details", void 0);
__decorate([
    Watch('incidentType', { immediate: true })
], detailsRight.prototype, "onUpdateIncidentType", null);
detailsRight = __decorate([
    Component({
        name: 'detailsRight',
        components: {
            detailsLevel,
            detailsType,
            detailsThreshold,
            detailsFace,
            detailsGatherScatter,
            detailsSocialDistance,
            detailsSnapArea,
            detailsStatus,
            detailsOperator,
            detailsRightBottom,
            detailsNote,
            traffic,
            AnalysisResult,
        },
        i18n: {
            messages: lang,
        },
    })
], detailsRight);
export default detailsRight;
